import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { device } from '../../../utils/constants';
import {
  LabBottomRule,
  labAos,
  labBodyMobile,
  labSectionPadMobile,
  labSubtitleMobile,
  labTitleMobile,
} from './labShared';

const Section = styled.section`
  color: #ffffff;
  font-family: Helvetica, Arial, sans-serif;
  box-sizing: border-box;
  padding-top: 5vw;
  ${labSectionPadMobile}
`;

const Title = styled.h2`
  margin: 0 auto;
  max-width: min(72rem, 100%);
  text-align: center;
  font-family: 'Horizon';
  font-size: 3vw;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  line-height: 1.2;
  ${labTitleMobile}

  @media ${device.mobile} {
    font-size: 1.5em;
  }
`;

const Grid = styled.div`
  margin: clamp(3rem, 8vw, 5rem) auto 0;
  max-width: min(72rem, 100%);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(2rem, 5vw, 3.5rem);

  @media ${device.mobile} {
    grid-template-columns: 1fr;
    gap: clamp(2rem, 6vw, 2.75rem);
    margin-top: clamp(2rem, 8vw, 3rem);
  }
`;

const Column = styled.article`
  border-left: 1px solid #ffffff;
  padding-left: 1vw;
  text-align: left;

  @media ${device.mobile} {
    padding-left: clamp(0.75rem, 4vw, 1rem);
  }
`;

const OutlineNum = styled.span`
  display: block;
  font-family: 'HorizonOutlined';
  font-size: 6vw;
  line-height: 0.6em;
  letter-spacing: 0.03em;
  text-transform: uppercase;

  @media ${device.mobile} {
    font-size: clamp(3rem, 14vw, 4.5rem);
  }
`;

const ColTitle = styled.h3`
  margin: clamp(1rem, 2vw, 1.35rem) 0 0;
  font-size: 1.6vw;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  line-height: 0.9;
  font-family: 'Horizon';
  ${labSubtitleMobile}
`;

const ColBody = styled.p`
  margin: 2vw 0 0;
  font-weight: 400;
  font-size: 1.1vw;
  line-height: 1.3;
  font-family: 'TelegrafLight';
  ${labBodyMobile}

  @media ${device.mobile} {
    margin-top: clamp(0.75rem, 3vw, 1rem);
  }
`;

const BottomBlock = styled.div`
  padding-top: 10vw;
  padding-bottom: 3vw;

  @media ${device.mobile} {
    padding-top: clamp(2.5rem, 10vw, 4rem);
    padding-bottom: clamp(1.5rem, 5vw, 2rem);
  }
`;

const TheEdgeLab = () => {
  const { t } = useTranslation();

  const EDGE_ITEMS = [
    {
      num: '01.',
      title: t('lab.theEdge.items.01.title'),
      body: t('lab.theEdge.items.01.body'),
    },
    {
      num: '02.',
      title: t('lab.theEdge.items.02.title'),
      body: t('lab.theEdge.items.02.body'),
    },
    {
      num: '03.',
      title: t('lab.theEdge.items.03.title'),
      body: t('lab.theEdge.items.03.body'),
    },
  ];

  return (
    <Section aria-labelledby="lab-the-edge-heading">
      <Title id="lab-the-edge-heading" {...labAos('fade-up')}>
        {t('lab.theEdge.title')}
      </Title>
      <Grid>
        {EDGE_ITEMS.map((item, index) => (
          <div
            key={item.num}
            {...labAos('fade-up', index * 150)}
            style={{ marginTop: device.mobile ? '1.2em' : 'auto' }}
          >
            <OutlineNum aria-hidden>{item.num}</OutlineNum>
            <Column>
              <ColTitle>{item.title}</ColTitle>
              <ColBody>{item.body}</ColBody>
            </Column>
          </div>
        ))}
      </Grid>
      <BottomBlock>
        <LabBottomRule aria-hidden />
      </BottomBlock>
    </Section>
  );
};

export default TheEdgeLab;
